import React from "react";
import { cn } from "@/lib/utils";

export default function InvertedCornerSvg({
  className,
  fill = "currentColor",
}: {
  className?: string;
  fill?: string;
}) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden="true"
    >
      <g clipPath="url(#inverted-corner-clip)">
        <mask
          id="inverted-corner-mask"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="32"
        >
          <path d="M0 0H32V32H0V0Z" fill="white" />
        </mask>
        <g mask="url(#inverted-corner-mask)">
          <path
            d="M79.9805 -76C53.4709 -76 31.9805 -54.5096 31.9805 -28V-0.00976562C31.9805 17.6633 17.6536 31.9902 -0.0195312 31.9902H-1762C-1808.39 31.9904 -1846 69.5984 -1846 115.99V2080C-1846 2126.4 -1808.39 2164 -1762 2164H334C380.392 2164 417.998 2126.4 417.998 2080V-28C417.998 -54.5096 396.508 -76 369.998 -76H79.9805Z"
            fill={fill}
          />
        </g>
      </g>
      <defs>
        <clipPath id="inverted-corner-clip">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="matrix(-1 0 0 1 32 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
